import { Route, Routes } from 'react-router-dom';
import { RequestAnalysisInfoHook, RequestAnalysisInfoContext } from './RequestAnalysisInfoContext';
import RequestAnalysisLanding from './RequestAnalysisLanding';
import RequestAnalysisSearch from './RequestAnalysisSearch';
import RequestAnalysisBulkSubmit from './RequestAnalysisBulkSubmit';
import RequestAnalysisUploadPackage from './RequestAnalysisUploadPackage';
import SubmissionQueueConfirmation from './SubmissionQueueConfirmation';
import Layout from '../../Layout/Layout';

export default function RequestAnalysis() {
  const { platform, setPlatform, numberOfSubmissions, setNumberOfSubmissions, submittedAt, setSubmittedAt } = RequestAnalysisInfoHook();
  return (
    <RequestAnalysisInfoContext.Provider
      value={{
        platform,
        setPlatform,
        numberOfSubmissions,
        setNumberOfSubmissions,
        submittedAt,
        setSubmittedAt,
      }}
    >
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<RequestAnalysisLanding />} />
          <Route path="bulk-submit" element={<RequestAnalysisBulkSubmit />} />
          <Route path="upload-package" element={<RequestAnalysisUploadPackage />} />
          <Route path="search" element={<RequestAnalysisSearch />} />
          <Route path="submission-confirmation" element={<SubmissionQueueConfirmation />} />
        </Route>
      </Routes>
    </RequestAnalysisInfoContext.Provider>
  );
}
